"use client";

import { useEffect, type ReactNode } from "react";
import Link from "next/link";
import { track } from "@/lib/analytics";
import { SOURCES } from "@/lib/analytics-events";

export default function PricingTracker() {
  useEffect(() => {
    track("pricing_view", SOURCES.pricingPage, {}, "/pricing");
  }, []);
  return null;
}

interface PricingCardProps {
  planSlug: string;
  className?: string;
  children: ReactNode;
}

export function PricingCard({ planSlug, className, children }: PricingCardProps) {
  const handleCardClick = () => {
    track("pricing_plan_card_clicked", SOURCES.pricingPage, { plan: planSlug }, "/pricing");
  };

  return (
    <div onClickCapture={handleCardClick} className={className} data-plan={planSlug}>
      {children}
    </div>
  );
}

interface PricingCtaLinkProps {
  href: string;
  planSlug: string;
  ctaLabel: string;
  className?: string;
  children: ReactNode;
}

export function PricingCtaLink({ href, planSlug, ctaLabel, className, children }: PricingCtaLinkProps) {
  const handleClick = () => {
    track("pricing_cta_clicked", SOURCES.pricingPage, { plan: planSlug, cta_label: ctaLabel, cta_href: href }, "/pricing");
  };
  return (
    <Link href={href} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}
